export function getBrand(): "ac" | "cp" {
	return (
		(document.documentElement.getAttribute("data-brand") as "ac" | "cp") ?? "ac"
	);
}

export const brandConfig = {
	ac: {
		redlineKey: import.meta.env.VITE_REDLINE_KEY_AC,
		ddAppId: import.meta.env.VITE_DD_RUM_APP_ID_AC,
		ddToken: import.meta.env.VITE_DD_RUM_TOKEN_AC,
		ddService: import.meta.env.VITE_DD_RUM_SERVICE_AC,
		identityAPIBaseURL: import.meta.env.VITE_ACP_IDENTITY_AC,
		acpAppName: "ac" as const,
		gtmKey: import.meta.env.VITE_GTM_KEY_AC,
		gaKey: import.meta.env.VITE_GA_KEY_AC,
		shKey: import.meta.env.VITE_SORTING_HAT_API_KEY_AC,
		companyName: "Acordo Certo",
	},
	cp: {
		redlineKey: import.meta.env.VITE_REDLINE_KEY_CP,
		ddAppId: import.meta.env.VITE_DD_RUM_APP_ID_CP,
		ddToken: import.meta.env.VITE_DD_RUM_TOKEN_CP,
		ddService: import.meta.env.VITE_DD_RUM_SERVICE_CP,
		identityAPIBaseURL: import.meta.env.VITE_ACP_IDENTITY_CP,
		acpAppName: "cp" as const,
		gtmKey: import.meta.env.VITE_GTM_KEY_CP,
		gaKey: import.meta.env.VITE_GA_KEY_CP,
		shKey: import.meta.env.VITE_SORTING_HAT_API_KEY_CP,
		companyName: "Consumidor Positivo",
	},
} as const;

export const config = brandConfig[getBrand()];
